module.exports = __webpack_public_path__ + "img/ercode_xmsc.fd116e03.png";